// extracted by mini-css-extract-plugin
export default {"content":"QJ-z","lookName":"RJ-z","shopTheLookContainer":"SJ-z","productContainer":"TJ-z","imageContainer":"UJ-z","mainImage":"VJ-z"};